import React, { useState, useEffect } from 'react';
import { BACKEND_URL } from '../config';
import { CheckCircle, Clock, ArrowsClockwise, ShieldCheck, WarningCircle } from '@phosphor-icons/react';

const TONE_ICON = {
  positive: CheckCircle,
  neutral: Clock,
  info: ShieldCheck,
  warning: WarningCircle,
};

const TONE_COLOR = {
  positive: 'text-[#00E5C0]',
  neutral: 'text-[#7D8896]',
  info: 'text-[#3B82F6]',
  warning: 'text-[#F59E0B]',
};

export default function ConfidenceSignals({ systemId }) {
  const [signals, setSignals] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!systemId) return;
    const fetchSignals = async () => {
      try {
        const res = await fetch(`${BACKEND_URL}/api/confidence/${systemId}`, { credentials: 'include' });
        if (!res.ok) return;
        const data = await res.json();
        setSignals(data.signals || []);
      } catch {
        // silent
      } finally {
        setLoading(false);
      }
    };
    fetchSignals();
  }, [systemId]);

  if (loading || signals.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-3" data-testid="confidence-signals">
      {signals.map((signal, i) => {
        const Icon = TONE_ICON[signal.tone] || CheckCircle;
        const color = TONE_COLOR[signal.tone] || 'text-[#7D8896]';
        return (
          <div
            key={i}
            className="flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-[rgba(255,255,255,0.03)] border border-[rgba(255,255,255,0.05)]"
            data-testid={`confidence-signal-${signal.type}`}
          >
            <Icon size={11} className={color} weight="bold" />
            <span className="text-[11px] text-[#B0B8C4]">{signal.label}</span>
          </div>
        );
      })}
    </div>
  );
}
